import React, { useEffect, useState } from 'react'

export const isBrowser = typeof window !== 'undefined'

export const isIOS = () => {
  if (isBrowser) {
    return /iPad|iPhone|iPod/.test(navigator.platform) && navigator.maxTouchPoints > 1
  }
}

export const HtmlTag = ({ tagName = 'h3', children, ...props }) => React.createElement(tagName, props, children)

export const Cta = ({ cta, children, ...props }) => {
  const { href, label, page } = cta

  // strapi does not support conditional fields
  // so do our error checking here
  if (!page && (!label || !href)) {
    return <></>
  }

  // default to linked pages with UGC overrides
  const path = href || page.path
  const copy = label || page.title

  return (
    <a href={path} {...props}>
      {children}
      <span>{copy}</span>
    </a>
  )
}

export const DOCTOR_BASE_SLUG = '/day-in-the-life'

export const DrSubTitle = ({ ...props }) => {
  return (
    <div {...props}>
      <strong>5</strong>&nbsp;PHYSICIANS. <strong>24</strong>&nbsp;HOURS.
    </div>
  )
}

export const faqDataFormatter = (pageData) => {
  const { main } = pageData

  // Need to aggregate all accordions into an array
  // Add that array to the new main without modifying
  // the other non accordion data
  const accordionsArr = []
  const newMain = []

  // Loop through main array and if the component is an accordion
  // It will add it to the accordionsArr
  // otherwise it will add it to newMain
  for (let i = 0; i < main.length; i++) {
    if (main[i].strapi_component === 'component.accordion') {
      accordionsArr.push(main[i])
      continue
    }
    newMain.push(main[i])
  }

  // Adds the accordionGroup Object with the value accordionsArr to newMain
  newMain.push({
    strapi_component: 'component.accordion-group',
    accordionGroup: accordionsArr,
  })

  const newPageData = { ...pageData, main: newMain }

  return newPageData
}

export const useResponsive = () => {
  const [isDesktop, setDesktop] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setDesktop(window.innerWidth > 768)
    }
  }, [])

  const updateMedia = () => {
    setDesktop(window.innerWidth > 768)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateMedia)
    }
    return () => window.removeEventListener('resize', updateMedia)
  })

  return [isDesktop, setDesktop]
}
